import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './cookieConsent.module.css';
import Accordion from './Accordion';
import { acceptCookieConsent, COOKIE_CONSENT_TYPES, rejectCookieConsent } from '../../utils/cookieConsent';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);
  const [customize, setCustomize] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) return null;

  const handleReject = () => {
    rejectCookieConsent();
    setIsVisible(false);
    window.location.reload();
  };

  function handleAccept(cookieType) {
    acceptCookieConsent(cookieType);
    setIsVisible(false);
    window.location.reload();
  }

  return customize ? (
    // eslint-disable-next-line react/jsx-no-bind
    <Customize handleReject={handleReject} handleAccept={handleAccept} />
  ) : (
    // eslint-disable-next-line react/jsx-no-bind
    <CookieOptions setCustomize={setCustomize} handleReject={handleReject} handleAccept={handleAccept} />
  );
}

function CookieOptions({ setCustomize, handleReject, handleAccept }) {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <p className={styles.title}>{t('cookieConsent.title')}</p>
      <div>
        <div>
          {}
          <p className={styles.caption}>{t('cookieConsent.description')}</p>
        </div>
        <div className={styles.buttonGroup}>
          <button type="button" onClick={() => setCustomize(true)} className={styles.button}>
            {t('cookieConsent.buttonGroup.button1')}
          </button>
          <button type="button" onClick={handleReject} className={styles.button}>
            {t('cookieConsent.buttonGroup.button2')}
          </button>
          <button type="button" onClick={() => handleAccept(COOKIE_CONSENT_TYPES.ALL)} className={styles.button}>
            {t('cookieConsent.buttonGroup.button3')}
          </button>
        </div>
      </div>
    </div>
  );
}

function Customize({ handleReject, handleAccept }) {
  const [checkedCookie, setCheckedCookie] = useState(COOKIE_CONSENT_TYPES.NECESSARY);
  const { t } = useTranslation();
  const PREFERENCES = [
    {
      id: 1,
      type: COOKIE_CONSENT_TYPES.NECESSARY,
      checked: true,
      label: t('cookieConsent.customize.title1'),
      description: t('cookieConsent.customize.description1'),
      cookie: [
        {
          id: 1,
          name: t('cookieConsent.customize.cookieDescription.cookie1.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie1.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie1.duration'),
        },
      ],
    },
    {
      id: 2,
      type: COOKIE_CONSENT_TYPES.ANALYTICS,
      checked: false,
      label: t('cookieConsent.customize.title2'),
      description: t('cookieConsent.customize.description2'),
      cookie: [
        {
          id: 1,
          name: t('cookieConsent.customize.cookieDescription.cookie6.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie6.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie6.duration'),
        },
        {
          id: 2,
          name: t('cookieConsent.customize.cookieDescription.cookie7.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie7.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie7.duration'),
        },
        {
          id: 3,
          name: t('cookieConsent.customize.cookieDescription.cookie8.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie8.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie8.duration'),
        },
        {
          id: 4,
          name: t('cookieConsent.customize.cookieDescription.cookie2.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie2.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie2.duration'),
        },
        {
          id: 5,
          name: t('cookieConsent.customize.cookieDescription.cookie3.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie3.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie3.duration'),
        },
        {
          id: 6,
          name: t('cookieConsent.customize.cookieDescription.cookie4.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie4.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie4.duration'),
        },
        {
          id: 7,
          name: t('cookieConsent.customize.cookieDescription.cookie5.name'),
          description: t('cookieConsent.customize.cookieDescription.cookie5.description'),
          duration: t('cookieConsent.customize.cookieDescription.cookie5.duration'),
        },
      ],
    },
  ];

  return (
    <div className={styles.customize}>
      <p className={styles['consent-title']}>{t('cookieConsent.customize.title3')}</p>
      <p className={styles['consent-description']}>{t('cookieConsent.customize.description3')}</p>
      <div className="">
        {PREFERENCES.map((pref) => (
          <div key={pref.id} className={styles['consent-content']}>
            <Accordion
              label={pref.label}
              description={pref.description}
              enabled={pref.type === COOKIE_CONSENT_TYPES.NECESSARY}
              onClick={() => setCheckedCookie(pref.type)}
              cookie={pref.cookie}
            />
          </div>
        ))}
        <div className={styles.buttonGroup}>
          <button type="button" onClick={handleReject} className={styles['customize-button']}>
            {t('cookieConsent.customize.buttonGroup.button1')}
          </button>
          <button type="button" onClick={() => handleAccept(checkedCookie)} className={styles['customize-button']}>
            {t('cookieConsent.customize.buttonGroup.button2')}
          </button>
        </div>
      </div>
    </div>
  );
}
